/* MBG product page enhancements — vanilla JS, no dependencies.
   Each piece only activates if its markup is present on the page. */
(function () {
  'use strict';

  /* Colour swatches: click a swatch -> drive the real <select> the
     existing variant engine already listens to, so all price/image/
     availability logic stays exactly as-is. */
  document.addEventListener('click', function (evt) {
    var swatch = evt.target.closest('.mbg-swatch');
    if (!swatch) return;

    var select = document.getElementById(swatch.getAttribute('data-mbg-swatch-for'));
    if (!select) return;

    select.value = swatch.getAttribute('data-mbg-swatch-value');
    select.dispatchEvent(new Event('change', { bubbles: true }));

    var group = swatch.closest('.mbg-swatch-group');
    if (group) {
      group.querySelectorAll('.mbg-swatch').forEach(function (el) {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });
    }
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');
  });

  /* Visible size tiles drive the native Shopify option select. The select
     remains the source of truth so the theme's existing variant, price,
     image and availability logic continues to work unchanged. */
  document.addEventListener('click', function (evt) {
    var sizeChip = evt.target.closest('.mbg-size-chip');
    if (!sizeChip) return;

    var select = document.getElementById(sizeChip.getAttribute('data-mbg-size-for'));
    if (!select) return;

    select.value = sizeChip.getAttribute('data-mbg-size-value');
    select.dispatchEvent(new Event('change', { bubbles: true }));

    var group = sizeChip.closest('.mbg-size-grid');
    if (group) {
      group.querySelectorAll('.mbg-size-chip').forEach(function (chip) {
        var selected = chip === sizeChip;
        chip.classList.toggle('is-selected', selected);
        chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }
  });

  /* Clean product gallery: the legacy thumbnail anchors remain in the
     DOM as the theme's proven image-switching engine, but are visually
     hidden. Swipe gestures and the small progress dots both drive those
     anchors, keeping variant-image behaviour intact without a second
     carousel library. */
  var galleryEl = document.querySelector('.product-single__photos');
  if (galleryEl) {
    var touchStartX = null;
    var thumbs = galleryEl.querySelectorAll('[class*="product-single__thumbnail--"]');
    var dots = galleryEl.querySelectorAll('[data-mbg-gallery-dot]');

    function activeGalleryIndex() {
      var activeIndex = 0;
      thumbs.forEach(function (thumb, i) {
        if (thumb.classList.contains('active-thumb')) activeIndex = i;
      });
      return activeIndex;
    }

    function syncGalleryProgress() {
      var activeIndex = activeGalleryIndex();
      dots.forEach(function (dot, i) {
        var active = i === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-mbg-gallery-index'), 10);
        if (!isNaN(index) && thumbs[index]) {
          thumbs[index].click();
          window.requestAnimationFrame(syncGalleryProgress);
        }
      });
    });

    thumbs.forEach(function (thumb) {
      if ('MutationObserver' in window) {
        new MutationObserver(syncGalleryProgress).observe(thumb, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    });

    galleryEl.addEventListener(
      'touchstart',
      function (evt) {
        touchStartX = evt.touches[0].clientX;
      },
      { passive: true }
    );

    galleryEl.addEventListener(
      'touchend',
      function (evt) {
        if (touchStartX === null) return;
        var deltaX = evt.changedTouches[0].clientX - touchStartX;
        touchStartX = null;

        if (Math.abs(deltaX) < 40 || !thumbs.length) return;

        var activeIndex = activeGalleryIndex();
        var nextIndex = deltaX < 0 ? activeIndex + 1 : activeIndex - 1;
        if (nextIndex >= 0 && nextIndex < thumbs.length) {
          thumbs[nextIndex].click();
          window.requestAnimationFrame(syncGalleryProgress);
        }
      },
      { passive: true }
    );

    syncGalleryProgress();
  }

  /* MBG native Klaviyo Notify control normalizer — finite retries, no observer. */
  (function () {
    var attempts = 0;
    var maxAttempts = 30;
    var timer;

    function setImportant(el, prop, value) {
      el.style.setProperty(prop, value, 'important');
    }

    function styleVisibleNotify(el, actionSlot) {
      if (!el || !actionSlot) return;

      setImportant(actionSlot, 'display', 'block');
      setImportant(actionSlot, 'width', '100%');
      setImportant(actionSlot, 'max-width', 'none');
      setImportant(actionSlot, 'padding-left', '0');
      setImportant(actionSlot, 'padding-right', '0');

      var parent = el.parentElement;
      while (parent && parent !== actionSlot) {
        setImportant(parent, 'box-sizing', 'border-box');
        setImportant(parent, 'width', '100%');
        setImportant(parent, 'max-width', 'none');
        setImportant(parent, 'min-width', '0');
        setImportant(parent, 'margin-left', '0');
        setImportant(parent, 'margin-right', '0');
        parent = parent.parentElement;
      }

      setImportant(el, 'appearance', 'none');
      setImportant(el, '-webkit-appearance', 'none');
      setImportant(el, 'box-sizing', 'border-box');
      setImportant(el, 'display', 'flex');
      setImportant(el, 'visibility', 'visible');
      setImportant(el, 'position', 'relative');
      setImportant(el, 'width', '100%');
      setImportant(el, 'max-width', 'none');
      setImportant(el, 'min-width', '100%');
      setImportant(el, 'height', '56px');
      setImportant(el, 'min-height', '56px');
      setImportant(el, 'margin', '0');
      setImportant(el, 'padding', '0 18px');
      setImportant(el, 'align-items', 'center');
      setImportant(el, 'justify-content', 'center');
      setImportant(el, 'border', '1px solid #111');
      setImportant(el, 'border-radius', '0');
      setImportant(el, 'background', '#111');
      setImportant(el, 'color', '#fff');
      setImportant(el, 'font-family', '"Helvetica Neue", Helvetica, Arial, sans-serif');
      setImportant(el, 'font-size', '12px');
      setImportant(el, 'font-weight', '600');
      setImportant(el, 'line-height', '1');
      setImportant(el, 'letter-spacing', '0.02em');
      setImportant(el, 'text-align', 'center');
      setImportant(el, 'text-indent', '0');
      setImportant(el, 'text-transform', 'uppercase');
      setImportant(el, 'text-decoration', 'none');
      setImportant(el, 'white-space', 'nowrap');
      setImportant(el, 'overflow', 'visible');
      setImportant(el, 'opacity', '1');
      setImportant(el, 'pointer-events', 'auto');

      el.querySelectorAll('*').forEach(function (child) {
        setImportant(child, 'margin', '0');
        setImportant(child, 'padding', '0');
        setImportant(child, 'visibility', 'visible');
        setImportant(child, 'opacity', '1');
        setImportant(child, 'color', '#fff');
        setImportant(child, 'font-family', '"Helvetica Neue", Helvetica, Arial, sans-serif');
        setImportant(child, 'font-size', '12px');
        setImportant(child, 'font-weight', '600');
        setImportant(child, 'line-height', '1');
        setImportant(child, 'letter-spacing', '0.02em');
        setImportant(child, 'text-align', 'center');
        setImportant(child, 'text-indent', '0');
        setImportant(child, 'text-transform', 'uppercase');
      });
    }

    function hideControl(el) {
      if (!el) return;
      setImportant(el, 'display', 'none');
      setImportant(el, 'visibility', 'hidden');
      setImportant(el, 'opacity', '0');
      setImportant(el, 'pointer-events', 'none');
    }

    function normalizeNotifyControls() {
      attempts += 1;

      document.querySelectorAll('.template-product .product-form__item--submit').forEach(function (actionSlot) {
        var hook = actionSlot.querySelector('[data-mbg-klaviyo-hook]');
        if (!hook) return;

        var candidates = Array.prototype.slice.call(
          actionSlot.querySelectorAll('a, button, [role="button"]')
        ).filter(function (el) {
          if (el === hook || hook.contains(el)) return false;
          var label = (el.textContent || el.getAttribute('aria-label') || '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();
          return label === 'notify me' ||
            label === 'notify me when available' ||
            label === 'notify me when back in stock';
        });

        if (candidates.length) {
          var working = candidates[0];

          /* The app-injected control is the one shoppers can actually use.
             Hide the theme hook and any extra duplicate controls. */
          hideControl(hook);
          candidates.slice(1).forEach(hideControl);
          styleVisibleNotify(working, actionSlot);
        } else {
          /* Before Klaviyo injects its live control, keep the hook looking
             correct as a temporary fallback. */
          styleVisibleNotify(hook, actionSlot);
        }
      });

      if (attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }

    normalizeNotifyControls();
    timer = window.setInterval(normalizeNotifyControls, 400);
  })();

  /* Product sharing: use the native mobile share sheet where supported;
     fall back to copying the product URL on older browsers. */
  document.addEventListener('click', function (evt) {
    var shareButton = evt.target.closest('[data-mbg-share-product]');
    if (!shareButton) return;

    var url = shareButton.getAttribute('data-share-url') || window.location.href;
    var title = shareButton.getAttribute('data-share-title') || document.title;
    var label = shareButton.querySelector('[data-mbg-share-label]');
    var status = shareButton.parentElement && shareButton.parentElement.querySelector('[data-mbg-share-status]');

    function copied() {
      if (label) label.textContent = 'Copied';
      if (status) status.textContent = 'Product link copied';
      window.setTimeout(function () {
        if (label) label.textContent = 'Share';
        if (status) status.textContent = '';
      }, 1800);
    }

    function copyFallback() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(copied).catch(function () {});
        return;
      }

      var textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        copied();
      } catch (err) {}
      document.body.removeChild(textarea);
    }

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        copyFallback();
      });
      return;
    }

    copyFallback();
  });

  /* Size guide / any other <dialog>-based modal on the page. Focus
     returns to whichever element opened it — covers the close button
     and the native Escape key, since both end up firing 'close'. */
  document.addEventListener('click', function (evt) {
    var opener = evt.target.closest('[data-mbg-open-dialog]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-mbg-open-dialog'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog._mbgOpener = opener;
        dialog.showModal();
      }
      return;
    }

    var closer = evt.target.closest('[data-mbg-close-dialog]');
    if (closer) {
      var openDialog = closer.closest('dialog');
      if (openDialog) openDialog.close();
    }
  });

  document.querySelectorAll('dialog').forEach(function (dialog) {
    dialog.addEventListener('close', function () {
      if (dialog._mbgOpener) dialog._mbgOpener.focus();
    });
  });

  /* Mobile sticky Add to Cart bar: reveal once the real buy box has
     scrolled out of view, mirror the live price via MutationObserver
     rather than re-implementing variant logic. */
  var stickyBar = document.querySelector('[data-mbg-sticky-bar]');
  var buyBox = document.querySelector('.product-form__item--submit');

  if (stickyBar && buyBox && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting;
        });
      },
      { rootMargin: '0px 0px -50% 0px' }
    );
    observer.observe(buyBox);

    var priceTarget = stickyBar.querySelector('[data-mbg-sticky-price]');
    var priceSource = document.querySelector('[id^="ProductPrice-"]');
    if (priceTarget && priceSource && 'MutationObserver' in window) {
      var priceObserver = new MutationObserver(function () {
        priceTarget.textContent = priceSource.textContent.trim();
      });
      priceObserver.observe(priceSource, { childList: true, characterData: true, subtree: true });
    }
  }

  /* "You May Also Like" — fetch Shopify's own recommendation results.
     Fails silently (section just stays empty) if the request fails. */
  var relatedPlaceholder = document.querySelector('.mbg-related[data-url]');
  if (relatedPlaceholder) {
    fetch(relatedPlaceholder.getAttribute('data-url'))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var populated = doc.querySelector('.mbg-related');
        if (populated) {
          relatedPlaceholder.outerHTML = populated.outerHTML;
          /* Assigning outerHTML parses <script> tags into real DOM nodes
             but browsers deliberately never execute scripts inserted this
             way — this is why mbg-rail-nav.js (the carousel arrow logic,
             fetched as part of this same fragment) has never actually run
             on a real product page: the tag was always there, it just
             never fired. Re-creating and appending each script tag found
             in the fetched fragment is the standard fix — a script
             element created via createElement + appendChild *does*
             execute, even though a parsed-and-inserted one doesn't. */
          doc.querySelectorAll('script[src]').forEach(function (oldScript) {
            var newScript = document.createElement('script');
            newScript.src = oldScript.src;
            document.body.appendChild(newScript);
          });
        }
      })
      .catch(function () {});
  }
})();


/* MBG Find My Fit — garment-aware premium assistant 2026-10-08 */
(function () {
  var sizes = ['XS','S','M','L','XL','2XL'];
  var drawer = document.querySelector('[data-mbg-fit-drawer]');
  if (!drawer) return;

  var garment = drawer.getAttribute('data-mbg-fit-garment') || 'top';
  var form = drawer.querySelector('[data-mbg-fit-form]');
  var result = drawer.querySelector('[data-mbg-fit-result]');
  var sizeOut = drawer.querySelector('[data-mbg-fit-size]');
  var copyOut = drawer.querySelector('[data-mbg-fit-copy]');
  var apply = drawer.querySelector('[data-mbg-fit-apply]');
  var error = drawer.querySelector('[data-mbg-fit-error]');

  var method = garment === 'jogger' ? 'waist' : 'measurements';
  var heightUnit = 'cm';
  var weightUnit = 'kg';
  var waistUnit = 'in';
  var preference = 'regular';
  var recommendation = '';

  function norm(v) {
    v = String(v || '').trim().toUpperCase().replace(/\s+/g,'');
    return v === 'XXL' ? '2XL' : v;
  }

  function hScore(cm) { if (cm<=162) return 0; if (cm<=169) return 1; if (cm<=177) return 2; if (cm<=185) return 3; if (cm<=192) return 4; return 5; }
  function wScore(kg) { if (kg<=53) return 0; if (kg<=63) return 1; if (kg<=76) return 2; if (kg<=90) return 3; if (kg<=105) return 4; return 5; }
  function waistScore(inches) { if (inches<=27) return 0; if (inches<=30) return 1; if (inches<=33) return 2; if (inches<=36) return 3; if (inches<=39) return 4; return 5; }
  function dressScore(size) { var n=Number(size); if (n<=6) return 0; if (n<=10) return 1; if (n<=12) return 2; if (n<=14) return 3; if (n<=16) return 4; return 5; }
  function suitScore(size) { var n=Number(size); if (n<=34) return 0; if (n<=36) return 1; if (n<=38) return 2; if (n<=42) return 3; if (n<=46) return 4; return 5; }

  function offeredSizes() {
    return Array.prototype.map.call(document.querySelectorAll('.mbg-size-chip'), function (chip) {
      return norm(chip.getAttribute('data-mbg-size-value'));
    }).filter(function (value, index, list) {
      return sizes.indexOf(value) !== -1 && list.indexOf(value) === index;
    });
  }

  function closestOffered(target, available) {
    if (!available.length || available.indexOf(target) !== -1) return target;
    var targetIndex=sizes.indexOf(target), best=available[0], bestDistance=99;
    available.forEach(function (value) {
      var index=sizes.indexOf(value);
      if(index<0) return;
      var distance=Math.abs(index-targetIndex);
      if(distance<bestDistance){best=value;bestDistance=distance;}
    });
    return best;
  }

  function setPressed(buttons, active, attribute) {
    buttons.forEach(function (button) {
      var isActive=button.getAttribute(attribute)===active;
      button.classList.toggle('is-active',isActive);
      if(button.hasAttribute('aria-selected')) button.setAttribute('aria-selected',isActive?'true':'false');
      if(button.hasAttribute('aria-pressed')) button.setAttribute('aria-pressed',isActive?'true':'false');
    });
  }

  function showError(message){ if(!error)return; error.textContent=message; error.hidden=!message; }
  var fitButtons = Array.prototype.slice.call(drawer.querySelectorAll('[data-mbg-fit-preference]'));
  var fitStep = fitButtons.length ? fitButtons[0].closest('.mbg-fit-step') : null;
  function resetResult(){
    if(result)result.hidden=true;
    recommendation='';showError('');
    fitButtons.forEach(function(button){button.hidden=false;});
    if(fitStep)fitStep.hidden=false;
  }
  form.addEventListener('input',resetResult);
  form.addEventListener('change',resetResult);

  function syncMethod(){
    drawer.querySelectorAll('[data-mbg-fit-method-panel]').forEach(function(panel){
      var active=panel.getAttribute('data-mbg-fit-method-panel')===method;
      panel.hidden=!active; panel.classList.toggle('is-active',active);
    });
    setPressed(Array.prototype.slice.call(drawer.querySelectorAll('[data-mbg-fit-method-button]')),method,'data-mbg-fit-method-button');
    resetResult();
  }

  function syncHeight(){
    drawer.querySelectorAll('[data-mbg-height-mode]').forEach(function(panel){panel.hidden=panel.getAttribute('data-mbg-height-mode')!==heightUnit;});
    setPressed(Array.prototype.slice.call(drawer.querySelectorAll('[data-mbg-height-unit]')),heightUnit,'data-mbg-height-unit');
    resetResult();
  }

  function syncWeight(){
    drawer.querySelectorAll('[data-mbg-weight-mode]').forEach(function(panel){panel.hidden=panel.getAttribute('data-mbg-weight-mode')!==weightUnit;});
    setPressed(Array.prototype.slice.call(drawer.querySelectorAll('[data-mbg-weight-unit]')),weightUnit,'data-mbg-weight-unit');
    resetResult();
  }

  function syncWaist(){
    drawer.querySelectorAll('[data-mbg-waist-mode]').forEach(function(panel){panel.hidden=panel.getAttribute('data-mbg-waist-mode')!==waistUnit;});
    setPressed(Array.prototype.slice.call(drawer.querySelectorAll('[data-mbg-waist-unit]')),waistUnit,'data-mbg-waist-unit');
    resetResult();
  }

  function syncPreference(){
    setPressed(Array.prototype.slice.call(drawer.querySelectorAll('[data-mbg-fit-preference]')),preference,'data-mbg-fit-preference');
    resetResult();
  }

  function close(){drawer.hidden=true;drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('mbg-fit-open');}
  function open(){drawer.hidden=false;drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('mbg-fit-open');window.setTimeout(function(){var first=drawer.querySelector('[data-mbg-fit-method-button]');if(first)first.focus();},30);}

  drawer.addEventListener('click',function(event){
    var methodButton=event.target.closest('[data-mbg-fit-method-button]');
    if(methodButton){method=methodButton.getAttribute('data-mbg-fit-method-button');syncMethod();return;}
    var heightButton=event.target.closest('[data-mbg-height-unit]');
    if(heightButton){heightUnit=heightButton.getAttribute('data-mbg-height-unit');syncHeight();return;}
    var weightButton=event.target.closest('[data-mbg-weight-unit]');
    if(weightButton){weightUnit=weightButton.getAttribute('data-mbg-weight-unit');syncWeight();return;}
    var waistButton=event.target.closest('[data-mbg-waist-unit]');
    if(waistButton){waistUnit=waistButton.getAttribute('data-mbg-waist-unit');syncWaist();return;}
    var fitButton=event.target.closest('[data-mbg-fit-preference]');
    if(fitButton){var hadResult=!result.hidden;preference=fitButton.getAttribute('data-mbg-fit-preference');syncPreference();if(hadResult)form.requestSubmit();}
  });

  document.addEventListener('click',function(event){
    if(event.target.closest('[data-mbg-fit-open]')){event.preventDefault();open();return;}
    if(event.target.closest('[data-mbg-fit-close]')){event.preventDefault();close();}
  });

  document.addEventListener('keydown',function(event){if(event.key==='Escape'&&!drawer.hidden)close();});

  function optionalHeight(){
    if(!form.elements.height_cm&&!form.elements.height_ft)return null;
    if(heightUnit==='imperial'){
      var feet=Number(form.elements.height_ft&&form.elements.height_ft.value);
      var inches=Number((form.elements.height_in&&form.elements.height_in.value)||0);
      if(!feet||inches<0||inches>11)return null;
      return(feet*30.48)+(inches*2.54);
    }
    var cm=Number(form.elements.height_cm&&form.elements.height_cm.value);
    return cm||null;
  }

  form.addEventListener('submit',function(event){
    event.preventDefault();
    showError('');

    var index=0, summary='', lengthNote='';

    if(garment==='jogger'&&method==='waist'){
      var waistIn;
      if(waistUnit==='cm'){
        var waistCm=Number(form.elements.waist_cm.value);
        if(!waistCm){showError('Enter your waist measurement in centimetres.');return;}
        waistIn=waistCm/2.54;
        summary=Math.round(waistCm)+'cm waist';
      }else{
        waistIn=Number(form.elements.waist_in.value);
        if(!waistIn){showError('Enter your waist measurement in inches.');return;}
        summary=waistIn+'in waist';
      }

      if(waistIn<22||waistIn>50){
        showError('That waist measurement sits outside the current fit-assistant range. Use the Size Chart for the closest garment comparison.');
        return;
      }

      index=waistScore(waistIn);

      var joggerHeight=optionalHeight();
      if(joggerHeight){
        if(joggerHeight<160) lengthNote=' At your height, check the Size Chart if you prefer less stacking at the ankle.';
        else if(joggerHeight>190) lengthNote=' At your height, check the Size Chart if you prefer extra leg length or stacking.';
      }
    }else if(method==='dress'){
      var dress=Number(form.elements.dress_size.value);
      if(!dress){showError('Choose your usual UK dress size.');return;}
      index=dressScore(dress);
      summary='UK dress size '+dress;
    }else{
      var heightCm,weightKg;
      if(heightUnit==='imperial'){
        var feet=Number(form.elements.height_ft.value);
        var inches=Number(form.elements.height_in.value||0);
        if(!feet||inches<0||inches>11){showError('Enter a valid height in feet and inches.');return;}
        heightCm=(feet*30.48)+(inches*2.54);
        summary=feet+'ft '+inches+'in';
      }else{
        heightCm=Number(form.elements.height_cm.value);
        if(!heightCm){showError('Enter your height in centimetres.');return;}
        summary=Math.round(heightCm)+'cm';
      }

      if(weightUnit==='lb'){
        var pounds=Number(form.elements.weight_lb.value);
        if(!pounds){showError('Enter your weight in pounds.');return;}
        weightKg=pounds*0.45359237;
        summary+=' · '+Math.round(pounds)+'lb';
      }else{
        weightKg=Number(form.elements.weight_kg.value);
        if(!weightKg){showError('Enter your weight in kilograms.');return;}
        summary+=' · '+Math.round(weightKg)+'kg';
      }

      if(heightCm<135||heightCm>215||weightKg<35||weightKg>180){
        showError('Those measurements sit outside the current fit-assistant range. Use the Size Chart for the closest garment comparison.');
        return;
      }
      index=Math.round((hScore(heightCm)+wScore(weightKg))/2);
      // Optional familiar-size reference is a secondary cross-check. It can move
      // the estimate by at most one size and never replaces garment measurements.
      var sizeReference=form.elements.reference_size ? String(form.elements.reference_size.value||'') : '';
      var parsedReference=/^(dress|suit)_(\d+)$/.exec(sizeReference);
      if(parsedReference){
        var refIndex=parsedReference[1]==='dress' ? dressScore(parsedReference[2]) : suitScore(parsedReference[2]);
        index=Math.max(index-1,Math.min(index+1,Math.round(index*0.65+refIndex*0.35)));
        summary+=' · '+(parsedReference[1]==='dress'?'UK dress size ':'UK suit jacket size ')+parsedReference[2];
      }
    }

    var baseIndex=index, offered=offeredSizes(), unique=[];
    var candidates=fitButtons.map(function(button,offset){
      var candidate=closestOffered(sizes[Math.min(sizes.length-1,baseIndex+offset)],offered);
      var duplicate=unique.indexOf(candidate)!==-1;
      if(!duplicate)unique.push(candidate);
      button.hidden=duplicate;
      return {preference:button.getAttribute('data-mbg-fit-preference'),size:candidate,duplicate:duplicate};
    });
    var selected=candidates.filter(function(candidate){return candidate.preference===preference;})[0];
    if(selected&&selected.duplicate){
      preference=candidates.filter(function(candidate){return candidate.size===selected.size&&!candidate.duplicate;})[0].preference;
      setPressed(fitButtons,preference,'data-mbg-fit-preference');
    }
    if(fitStep)fitStep.hidden=unique.length===1;
    if(preference==='oversized')index+=1;
    if(preference==='very-oversized')index+=2;
    index=Math.max(0,Math.min(sizes.length-1,index));

    recommendation=closestOffered(sizes[index],offeredSizes());
    sizeOut.textContent=recommendation;

    var fitLabel;
    if(garment==='jogger') fitLabel=preference==='regular'?'Standard':preference==='oversized'?'Relaxed':'Extra relaxed';
    else fitLabel=preference==='regular'?'Regular':preference==='oversized'?'Oversized':'Very oversized';

    copyOut.textContent=summary+(unique.length===1?' · One size recommendation matches these measurements.':' · '+fitLabel+' fit.')+' This is the closest match from this product’s size range; stock availability is shown when you select it. Garment sizes are approximate and for guidance only.'+lengthNote;
    result.hidden=false;
  });

  apply.addEventListener('click',function(){
    if(!recommendation)return;
    var chips=document.querySelectorAll('.mbg-size-chip');
    for(var i=0;i<chips.length;i++){
      if(norm(chips[i].getAttribute('data-mbg-size-value'))===recommendation){
        chips[i].click();close();chips[i].focus();break;
      }
    }
  });

  syncMethod();syncHeight();syncWeight();syncWaist();syncPreference();
})();


/* MBG Find My Fit runtime style sync — 2026-10-08 */
(function () {
  var attempts = 0;
  var maxAttempts = 40;
  var timer;

  function normalizedText(el) {
    return (el && el.textContent ? el.textContent : '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function findSizeChartText(root) {
    if (!root) return null;

    var nodes = root.querySelectorAll('*');
    var fallback = null;

    for (var i = 0; i < nodes.length; i += 1) {
      var el = nodes[i];
      if (normalizedText(el) !== 'size chart') continue;

      fallback = fallback || el;

      var childMatches = false;
      for (var j = 0; j < el.children.length; j += 1) {
        if (normalizedText(el.children[j]) === 'size chart') {
          childMatches = true;
          break;
        }
      }
      if (!childMatches) return el;
    }

    return fallback;
  }

  function syncFindMyFit() {
    attempts += 1;

    var kiwi = document.getElementById('KiwiSizingChart');
    var fit = document.querySelector('.mbg-find-fit-trigger');
    var reference = findSizeChartText(kiwi);

    if (fit && reference) {
      var style = window.getComputedStyle(reference);
      var props = [
        'font-family',
        'font-size',
        'font-weight',
        'font-style',
        'font-stretch',
        'font-kerning',
        'font-feature-settings',
        'line-height',
        'letter-spacing',
        'text-transform',
        'text-decoration-line',
        'text-decoration-style',
        'text-decoration-thickness',
        'text-underline-offset',
        'color'
      ];

      props.forEach(function (prop) {
        var value = style.getPropertyValue(prop);
        if (value) fit.style.setProperty(prop, value, 'important');
      });

      /* Kiwi's underline is inherited/applied by its wrapper rather than the
         exact text node we sample, so explicitly keep the same visible
         underline on Find My Fit after copying the text metrics. */
      fit.style.setProperty('text-decoration-line', 'underline', 'important');
      fit.style.setProperty('text-decoration-style', 'solid', 'important');
      fit.style.setProperty('text-decoration-thickness', '1px', 'important');
      fit.style.setProperty('text-underline-offset', '2px', 'important');

      fit.style.setProperty('top', '0', 'important');
      fit.style.setProperty('transform', 'none', 'important');

      /* Match the rendered vertical centre, not just the CSS line-height.
         This compensates for Kiwi's icon/text wrapper without moving anything else. */
      var refRect = reference.getBoundingClientRect();
      var fitRect = fit.getBoundingClientRect();
      var delta = ((refRect.top + refRect.height / 2) - (fitRect.top + fitRect.height / 2));

      if (Math.abs(delta) > 0.25) {
        fit.style.setProperty('transform', 'translateY(' + delta.toFixed(2) + 'px)', 'important');
      }

      /* Keep checking briefly because Kiwi may apply its final injected styles
         a moment after its text first appears. */
      if (attempts >= 8) {
        window.clearInterval(timer);
      }
      return;
    }

    if (attempts >= maxAttempts) {
      window.clearInterval(timer);
    }
  }

  syncFindMyFit();
  timer = window.setInterval(syncFindMyFit, 250);
})();


/* MBG gift recipient fields — 2026-10-09 */
(function () {
  var block = document.querySelector('[data-mbg-gift-recipient]');
  if (!block) return;

  var toggle = block.querySelector('[data-mbg-gift-recipient-toggle]');
  var fields = block.querySelector('[data-mbg-gift-recipient-fields]');
  var flag = block.querySelector('[data-mbg-gift-recipient-flag]');
  var inputs = Array.prototype.slice.call(block.querySelectorAll('[data-mbg-recipient-field]'));

  function sync() {
    var active = !!(toggle && toggle.checked);
    fields.hidden = !active;
    if (flag) flag.disabled = !active;
    inputs.forEach(function (input) { input.disabled = !active; });
    var email = block.querySelector('[name="properties[Recipient email]"]');
    if (email) email.required = active;
    inputs.forEach(function (input) {
      if (!active) input.setCustomValidity('');
    });
  }

  var sendOn = block.querySelector('[name="properties[Send on]"]');
  if (sendOn) {
    var today = new Date();
    var latest = new Date();
    latest.setDate(latest.getDate() + 90);
    function localDate(date) { return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0'); }
    sendOn.min = localDate(today);
    sendOn.max = localDate(latest);
  }
  if (toggle) toggle.addEventListener('change', sync);
  sync();
})();

